exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#swagger-editor #ace-editor{height:calc(100vh - 46px)!important}#swagger-editor .SplitPane{height:calc(100% - 46px)!important}.editor-wrapper .editor-readonly-watermark{position:absolute;top:0;height:40px;left:0;right:0;padding-right:20px;padding-top:10px;margin:0;z-index:2;color:#fff;font-weight:700;text-align:right;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none}.editor-wrapper .editor-readonly-watermark:before{z-index:1;pointer-events:none;position:absolute;content:\" \";top:0;left:0;right:0;bottom:0;background:linear-gradient(90deg,hsla(0,0%,100%,0) 60%,hsla(0,0%,57%,.31) 74%,hsla(0,0%,100%,.17))}@media print{.Pane1,.topbar{display:none}.SplitPane{position:relative!important;display:block!important}.Pane2{overflow-y:auto;width:100%!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/less-loader!./src/plugins/editor/components/editor.less
// module id = 1164
// module chunks = 0